/*********************************************
 *  Occupational Medicine Appointment Namespace
 ********************************************/

window.occupationalMedicineNS = {
    _action: null,
    _callback: null,
    _row: null,

    executeAction: function(action, row, callback) {

        var wfId = parseInt(action.wf_id);
        var actionId = parseInt(action.wf_action_id);

        this._action = action;
        this._callback = callback;
        this._row = row;

        if (wfId == 53) { // appointment
            if (actionId == globalConstants.ACTION_CANCEL) {
                occupationalMedicineNS.openCancelAppointmentModal();
            } else if (actionId == globalConstants.ACTION_JUSTIFY_ABSENCE) {
                occupationalMedicineNS.openPatientAbsence(occupationalMedicineNS.setPatientAbsenceModalHandler);
            } else if (actionId == globalConstants.ACTION_RESCHEDULE_APPOINTMENT) {
                occupationalMedicineNS.openScheduler();
            } else {
                occupationalMedicineNS.executeGenericAction();
            }
        } else if (wfId == 38 ) { // episode
            if (actionId == globalConstants.ACTION_UNDO_WEARER_ARRIVE) {
                occupationalMedicineNS.openReason(occupationalMedicineNS.undoPatientArrivalReasonModalHandler);
            } else if (actionId == globalConstants.ACTION_UNDO_START_EPISODE) {
                occupationalMedicineNS.openReason(occupationalMedicineNS.undoStartEpisode);
            } else if (actionId == globalConstants.ACTION_UNDO_FINALIZE_EPISODE) {
                occupationalMedicineNS.openReason(occupationalMedicineNS.undoFinalizeEpisode);
            } else if (actionId == globalConstants.ACTION_UNDO_START_ADMINISTRATIVE_SERVICE || actionId == globalConstants.ACTION_UNDO_FINALIZE_ADMINISTRATIVE_SERVICE) {
                occupationalMedicineNS.openReason(occupationalMedicineNS.administrativeActions);
            } else {
                occupationalMedicineNS.executeGenericAction();
            }
        }

    },

    openCancelAppointmentModal: function(){
        Hades.showLoading();

        var params = {
            task_id: occupationalMedicineNS._action.task_id,
            wf_id: occupationalMedicineNS._action.wf_id,
            wf_status_id: null,
            wf_action_id: occupationalMedicineNS._action.wf_action_id
        };

        $.get('/modal/generic_reason_window', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content:data, autoScale:true, autoDimensions:true});

                $('#generic-reason-modal-ct').bind('genericReasonConfirmed', occupationalMedicineNS.cancelAppointment);

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                occupationalMedicineNS._callback(false, occupationalMedicineNS._action, occupationalMedicineNS._row);
            });
    },

    cancelAppointment: function (event, data) {
        $.fancybox.close(true);

        var params = {
            task_id: occupationalMedicineNS._row.task_id,
            reason_id:data.reasonId,
            other_reason:data.otherReason,
            cancel_date:data.date,
            cancel_hour:data.hour,
            wf_id: occupationalMedicineNS._row.wf_id,
            wf_status_id: occupationalMedicineNS._row.wf_status_id,
            wf_action_id:data.actionId
        };

        $.post('/episode/cancel_episode', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(data.error, xhr.responseText, xhr, status, data.error);
                    Hades.hideLoading();
                    occupationalMedicineNS._callback(false, occupationalMedicineNS._action, occupationalMedicineNS._row);
                } else {
                    occupationalMedicineNS._callback(true, occupationalMedicineNS._action, occupationalMedicineNS._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                occupationalMedicineNS._callback(false, occupationalMedicineNS._action, occupationalMedicineNS._row);
            });
    },

    openPatientAbsence: function (callback) {
        var params = {
            task_id: occupationalMedicineNS._action.task_id,
            wf_id: occupationalMedicineNS._action.wf_id,
            wf_status_id: occupationalMedicineNS._action.to_state_id,
            wf_action_id: occupationalMedicineNS._action.wf_action_id
        };
        Hades.showLoading();
        $.get('/appointments/patient_absence_modal', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);


                $.fancybox({content:data, autoScale:true, autoDimensions:true});

                $('#patient-absence-modal-ct').bind('patientAbsenceConfirmed', callback);

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                occupationalMedicineNS._callback(false, occupationalMedicineNS._action, occupationalMedicineNS._row);
            });
    },

    setPatientAbsenceModalHandler: function (event, data) {
        Hades.hideLoading();
        $.fancybox.close();
        occupationalMedicineNS._action.to_state_id = data.state_id;
        occupationalMedicineNS._callback(true, occupationalMedicineNS._action, occupationalMedicineNS._row);
    },

    openScheduler:function(){

        debug.log("1",occupationalMedicineNS._action);
        var params = {
            task_id: occupationalMedicineNS._action.task_id,
            wf_id: occupationalMedicineNS._action.wf_id,
            wf_status_id: occupationalMedicineNS._action.to_state_id,
            wf_action_id: occupationalMedicineNS._action.wf_action_id,
            wf_from_state_id: occupationalMedicineNS._action.from_state_id,
            financial_institution_id: occupationalMedicineNS._action.params.financial_institution_id
        };

        params.width = $(window).width();
        params.can_change_appointment_type = "0";
        params.can_change_specialty = "0";
        params.can_change_professional = "0";
        params.can_change_financial_institution = "0";
        params.show_week_button = false;

        $.get('/calendar/calendar_pick_date', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content:data});

                $('#calendar-pick-date-ct').bind('dateSelected', occupationalMedicineNS.onSchedulerCloseHandler);
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
            });
    },
    onSchedulerCloseHandler:function(event, data) {
        $.fancybox.close(true);

        var params = {};
        params.professional_id = data.resource_id;
        params.professional_name = data.resource_desc;
        params.prev_date = data.prev_date;
        params.prev_hour = data.prev_hour;
        params.date = data.date;
        params.hour = data.hour;
        params.prev_professional_name = data.prev_professional_name;
        params.specialty_id = data.specialty_id;
        params.task_id = occupationalMedicineNS._action.task_id;
        params.wf_id = occupationalMedicineNS._action.wf_id;
        params.wf_status_id = null;
        params.wf_action_id = occupationalMedicineNS._action.wf_action_id;

        $.get('/physiotherapy/confirm_session_reschedule', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content:data, autoScale:true, autoDimensions:true});

                $('#generic-reason-modal-ct').bind('genericReasonConfirmed', occupationalMedicineNS.rescheduleSession);

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
            });
    },
    rescheduleSession: function(evt, data){
        $.fancybox.close(true);

        Hades.showLoading();

        var params = {};
        params.appointment_id = data.appointment_id;
        params.professional = data.professional_id;
        params.specialty = data.specialty_id;
        params.app_date = data.date;
        params.app_hour = data.hour;
        params.reason_id = data.reasonId;
        params.reason_desc = data.otherReason;

        $.post('/appointments/reschedule_appointment', params)
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success == false) {
                    bootbox.alert(data.error);
                    //Hades.showError(Hades.genericErrorMsg(), data.error, xhr, status, data.error);
                    occupationalMedicineNS._callback(false, occupationalMedicineNS._action, occupationalMedicineNS._row);
                } else {
                    occupationalMedicineNS._callback(true, occupationalMedicineNS._action, occupationalMedicineNS._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
            });
    },
    openReason:function (callback) {

        var params = {
            task_id: occupationalMedicineNS._action.task_id,
            wf_id: occupationalMedicineNS._action.wf_id,
            wf_status_id: occupationalMedicineNS._action.to_state_id,
            wf_from_state_id: occupationalMedicineNS._action.from_state_id,
            wf_action_id: occupationalMedicineNS._action.wf_action_id
        };

        $.get('/modal/generic_reason_window', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content:data, autoScale:true, autoDimensions:true});

                $('#generic-reason-modal-ct').bind('genericReasonConfirmed', callback);

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                episode._callback(false, episode._action, episode._row);
            });
    },

    undoPatientArrivalReasonModalHandler:function (event, data) {
        $.fancybox.close(true);

        var params = {
            task_id: occupationalMedicineNS._row.task_id,
            reason_id: data.reasonId,
            other_reason: data.otherReason,
            date: data.date,
            hour: data.hour,
            wf_id: occupationalMedicineNS._row.wf_id,
            wf_status_id: occupationalMedicineNS._row.wf_status_id,
            wf_action_id: data.actionId};

        $.post('/episode/undo_patient_arrival', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    occupationalMedicineNS._callback(false, occupationalMedicineNS._action, occupationalMedicineNS._row);
                } else {
                    occupationalMedicineNS._callback(true, occupationalMedicineNS._action, occupationalMedicineNS._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                occupationalMedicineNS._callback(false, occupationalMedicineNS._action, occupationalMedicineNS._row);
            });
    },

    undoStartEpisode: function(event, data) {
        Hades.showLoading();
        $.fancybox.close(true);

        var params = {
            task_id: occupationalMedicineNS._row.task_id,
            reason_id: data.reasonId,
            other_reason: data.otherReason,
            date: data.date,
            hour: data.hour,
            wf_id: occupationalMedicineNS._row.wf_id,
            wf_status_id: data.wf_from_state_id,
            wf_action_id: data.wf_action_id};

        $.post('/episode/undo_start_episode', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    occupationalMedicineNS._callback(false, occupationalMedicineNS._action, occupationalMedicineNS._row);
                } else {
                    occupationalMedicineNS._callback(true, occupationalMedicineNS._action, occupationalMedicineNS._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                occupationalMedicineNS._callback(false, occupationalMedicineNS._action, occupationalMedicineNS._row);
            });
    },

    undoFinalizeEpisode: function(event, data) {
        Hades.showLoading();
        $.fancybox.close(true);

        var params = {
            task_id: occupationalMedicineNS._row.task_id,
            reason_id: data.reasonId,
            other_reason: data.otherReason,
            date: data.date,
            hour: data.hour,
            wf_id: occupationalMedicineNS._row.wf_id,
            wf_status_id: data.wf_from_state_id,
            wf_action_id: data.wf_action_id};

        $.post('/episode/undo_finalize_episode', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    occupationalMedicineNS._callback(false, occupationalMedicineNS._action, occupationalMedicineNS._row);
                } else {
                    occupationalMedicineNS._callback(true, occupationalMedicineNS._action, occupationalMedicineNS._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                occupationalMedicineNS._callback(false, occupationalMedicineNS._action, occupationalMedicineNS._row);
            });
    },

    administrativeActions: function(event, data) {
        $.fancybox.close(true);
        var params = {
            task_id: occupationalMedicineNS._row.task_id,
            reason_id: data.reasonId,
            other_reason: data.otherReason,
            date: data.date,
            hour: data.hour,
            wf_id: occupationalMedicineNS._row.wf_id,
            wf_status_id: data.wf_status_id,
            wf_action_id: data.wf_action_id};

        $.post('/episode/administrative_actions', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    occupationalMedicineNS._callback(false, occupationalMedicineNS._action, occupationalMedicineNS._row);
                } else {
                    occupationalMedicineNS._callback(true, occupationalMedicineNS._action, occupationalMedicineNS._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                occupationalMedicineNS._callback(false, occupationalMedicineNS._action, occupationalMedicineNS._row);
            });
    },

    executeGenericAction: function () {
        debug.log('occupationalMedicineNS -> executeGenericAction');
        workflow.executeGenericAction(occupationalMedicineNS._action, occupationalMedicineNS._callback, occupationalMedicineNS._row);
    }
}
